<template>
  <div class="panelisttooltip">
    <v-row>
      <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align"></v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <DatePicker label="Date" :date="panelist.pp_date" @choose="chooseDate" :disable_future="true" />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align"></v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field label="Invitation ID" outlined dense v-model="panelist.invitation_id" />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align"></v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field label="Last 4 Digits" outlined dense v-model="panelist.tracking_id" />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align"></v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field label="Panelist" outlined dense v-model='fetchpanelist' />
        <div id="panelisttooltip__tooltip" v-if="allpanelist.length > 0">
          <ul id="panelisttooltip__tooltip--list">
            <li v-for="(p, i) in allpanelist" :key="i" v-ripple @click.prevent="choosePanelist(p)">
              <span v-if="isAlreadyExists(p)">*</span>{{ p.competi_id }} ({{ p.name }}) / {{ state_abb(p) }}
            </li>
          </ul>
        </div>
      </v-col>
      <v-col :cols="3" class="text-left no-right no-bottom no-top">
        <v-progress-circular
          :width="3"
          :size="20"
          color="primary"
          indeterminate
          v-if="showSpinner">
        </v-progress-circular>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="3"></v-col>
      <v-col :cols="6">
        <v-btn small color="primary" @click.prevent="close">Close</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import DatePicker from './../../utilities/DatePicker'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductTooltip',
  props: {
    entryDate: String  // This prop should receive the entry date from parent
  },
  data: () => ({
    fetchpanelist: '',
    allpanelist: [],
    showSpinner: false,
    panelist: {
      pp_date: '',
      competi_id: '',
      invitation_id: '',
      panelist_id: '',
      tracking_id: '',
      age: '',
      gender: '',
      incomeID: '',
      stateID: '',
      name: '',
    }
  }),
  mounted() {
    // Initialize panelist date with entry date from props or last panelist date
    if (this.entryDate) {
      this.panelist.pp_date = this.entryDate;
    } else {
      const panelists = this.$store.getters["ProductData/getPanelists"]
      if (panelists.length > 0) {
        const last_panelist = panelists[panelists.length - 1]
        this.panelist.pp_date = last_panelist.pp_date
      }
    }
  },
  components: {
    DatePicker
  },
  computed: {
    ...mapGetters({
      state_specific: 'ProductData/getStateSpecific',
    })
  },
  methods: {
    state_abb(p) {
      const raw_states = this.$store.getters["ProductData/getRawProductStates"];
      const match = raw_states.find(rs => rs.stateID == p.stateID);
      return match ? match.stateCode : '';
    },

    // Updated method to ensure date matches entry date
    chooseDate(selectedDate) {
      // Helper to get YYYY-MM-DD string from Date or string input
      function toYMD(date) {
        if (!date) return '';
        if (typeof date === 'string') {
          // Try to parse string as Date first
          const parsed = new Date(date);
          if (!isNaN(parsed)) return parsed.toISOString().slice(0, 10);
          return date.slice(0, 10); // fallback, if already YYYY-MM-DD format
        }
        if (date instanceof Date) {
          return date.toISOString().slice(0, 10);
        }
        return '';
      }

      const selected = toYMD(selectedDate);
      // Compare with entry date from props if available, otherwise use current panelist date
      const allowedDate = this.entryDate || this.panelist.pp_date;
      const allowed = toYMD(allowedDate);

      if (selected === allowed) {
        this.panelist.pp_date = selectedDate;
      } else {
        // this.$swal.fire({
        //   icon: "warning",
        //    position: "bottom-end",
        //   title: "Invalid Date",
        //   text: `Panelist Date should be same as Entry Date: ${allowed}`,
        //   confirmButtonText: "OK"
        // });
        // Reset to the correct date
        this.panelist.pp_date = allowedDate;
      }
    },

    close() {
      this.$emit('closePanelist', false);
      this.$emit('editDate');
      const dates = this.$store.getters["ProductData/getPanelists"].map(p => p.pp_date);
      dates.sort((a, b) => new Date(b) - new Date(a));
      if (dates.length > 0) {
        this.$store.dispatch("ProductData/setEntryDate", dates[0]);
      }
    },

    choosePanelist(p) {
      if (!this.panelist.pp_date) {
        alert('Please choose date.');
        return;
      }

      if (p.competi_id && p.panelist_id) {
        this.panelist = {
          ...this.panelist,
          ...p,
          name: `${p.name}`
        };
        this.allpanelist = [];

        if (this.isAlreadyExists(p)) {
          this.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title: "Panelist already selected!",
          });
        } else if (this.state_specific) {
          const selected = this.$store.getters["ProductData/getPanelists"];
          const differentState = selected.some(o => o.stateID && p.stateID && o.stateID != p.stateID);

          if (differentState) {
            this.$swal.fire({
              position: "bottom-end",
              icon: "error",
              title: "Panelist of different states are not allowed when state specific is checked!",
            });
          } else {
            this.setPanelist(this.panelist);
          }
        } else {
          this.setPanelist(this.panelist);
        }
      }
    },

    setPanelist(p) {
      const selected_states = this.$store.getters["ProductData/getStateProvince"];
      const product_age = this.$store.getters["ProductData/getProductAge"];
      const product_income = this.$store.getters["ProductData/getProductIncome"];
      const selected_panelists = this.$store.getters["ProductData/getPanelists"];

      this.$store.dispatch('ProductData/setProductPanelists', p).then(() => this.close());

      if (!selected_states.includes(p.stateID) && p.stateID != 0) {
        selected_states.push(p.stateID);
        this.$store.dispatch("ProductData/setStateProvince", []);
        this.$store.dispatch("ProductData/setStateProvince", selected_states);
      }

      if (p.age && !product_age.includes(p.age)) {
        product_age.push(p.age);
        this.$store.dispatch("ProductData/setProductAge", []);
        this.$store.dispatch("ProductData/setProductAge", product_age);
      }

      if (p.incomeID && !product_income.includes(p.incomeID)) {
        product_income.push(p.incomeID);
        this.$store.dispatch("ProductData/setProductIncome", []);
        this.$store.dispatch("ProductData/setProductIncome", product_income);
      }

      if (p.gender) {
        const hasBoth = selected_panelists.some(o => o.gender && o.gender !== p.gender);
        this.$store.dispatch("ProductData/setGender", '');
        this.$store.dispatch("ProductData/setGender", hasBoth ? "B" : p.gender);
      }
    },

    isAlreadyExists(p) {
      const pans = this.$store.getters['ProductData/getPanelists'];
      return pans.some(o => o.competi_id === p.competi_id && o.panelist_id === p.panelist_id);
    }
  },
  watch: {
    fetchpanelist(v) {
      if (v.length > 1) {
        this.showSpinner = true;
        this.$fetch({
          url: this.$url('API') + 'panelists/' + v,
          type: 'GET',
        }, {
          operation: 'view',
          vueScope: this
        }).then(response => {
          setTimeout(() => this.showSpinner = false, 500);
          this.allpanelist = response.map(o => ({
            competi_id: o.competi_id,
            name: `${o.first_name} ${o.last_name}`,
            panelist_id: o.panelist_id,
            age: Math.floor(o.age / 10),
            gender: o.gender,
            incomeID: o.incomeID,
            stateID: o.stateID
          }));
        }).catch(() => this.showSpinner = false);
      } else {
        this.allpanelist = [];
        this.showSpinner = false;
      }
    },
    
    // Watch for changes in entry date prop
    entryDate(newDate) {
      if (newDate) {
        this.panelist.pp_date = newDate;
      }
    }
  }
}
</script>

<style scoped lang="sass">
@import './../../assets/sass/product/producttooltip'

.v-progress-circular
  top: 25%
</style>